import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//helpers
import { screen } from '@/helpers/screen';

export const DiffWrapper = styled.section`
  --numfs: clamp(36px, 3.4vw, 48px);

  min-width: 0;
  padding: var(--pad, 96px) 0;
  font: 400 16px/1.6 ${getToken('font-family-default')};
  background: rgb(${getToken('color-background-secondary')});
  color: rgb(${getToken('color-text-primary')});
`;

export const Title = styled.h2`
  margin: 0 0 var(--gap-h2, 56px);
  font: 700 clamp(28px, 3.2vw, 36px) / 1.2 ${getToken('font-family-title')};
  letter-spacing: -0.015em;
  text-align: center;
  color: rgb(${getToken('color-primary-60')});
  text-wrap: balance;
`;

export const DiffGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0 24px;

  ${screen.md} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const DiffItem = styled.article`
  display: grid;
  margin-bottom: 24px;
  padding: 28px 24px 32px;
  background: #fff;
  border: 1px solid rgb(${getToken('color-background-tertiary')});
  border-radius: 16px;

  ${screen.md} {
    grid-template-rows: subgrid;
    grid-row: span 3;
    row-gap: 0;
    padding: 36px 36px 40px;
  }
`;

export const DiffNumber = styled.p`
  align-self: end;
  margin: 0 0 20px;
  font: 700 var(--numfs) / 1.05 ${getToken('font-family-default')};
  letter-spacing: -0.02em;
  color: rgb(${getToken('color-primary-60')});
  white-space: normal;
  word-spacing: ${({ $tight }) => ($tight ? '-0.05em' : 'normal')};
  text-wrap: ${({ $wrap }) => ($wrap ? 'balance' : 'wrap')};

  ${screen.lg} {
    white-space: ${({ $wrap }) => ($wrap ? 'normal' : 'nowrap')};
  }
`;

export const DiffTitle = styled.h3`
  margin: 0 0 12px;
  font: 600 22px/1.3 ${getToken('font-family-title')};
  color: rgb(${getToken('color-text-primary')});
`;

export const DiffCopy = styled.p`
  margin: 0;
  font: 400 16px/1.65 ${getToken('font-family-default')};
  color: rgb(${getToken('color-text-secondary')});

  a {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;
